export const SUCCESS_COLOR = '#00B085';
export const SUCCESS_90 = '#EDF5ED';
export const ERROR_COLOR = '#CC0000';
export const WARNING_COLOR = '#F48503';
export const IMPORTANT_COLOR = '#FFD45C';
export const IMPORTANT_COLOR_OPAQUE = 'rgba(255, 212, 92, .5)';
export const BRAND_GREEN = '#32CAA2';
export const NEUTRAL_COLOR_LEVEL_1 = '#B2ADA6';
export const WARNING_TEXT_COLOR = '#F2994A';
export const BATTERY_CHARGE = 'rgba(0, 176, 133, .8)';
export const DARK_BLUE_COLOR = '#001A3C';
export const DARK_COLOR = '#01193F';
export const SECONDARY_COLOR = '#0087FF';
export const HIGHLIGHTED_RADIO_BACKGROUND_COLOR = '#32CAA2';
export const WHITE_COLOR = '#FFFFFF';

export const INFO_BANNER_BACKGROUD = '#EDF4FB';
export const INFO_ICON_DARK_BLUE = '#1F2647';
export const INFO_BANNER_TEXT_COLOR = '#012F59';
export const INFO_BORDER_COLOR = '#A3A09A';
export const INFO_BACKGROUND_COLOR = '#141930';

export const GRAY_BORDER_COLOR = NEUTRAL_COLOR_LEVEL_1;
export const GRAY_BORDER_COLOR_2 = '#B2ADA6';
export const DESTRUCTIVE_COLOR = '#E21717';
export const LIGHT_GRAY_HR = '#DEDBD6';
export const OTHER_GRAY_HR = '#C4C4C4';

export const SYSTEM_ACTIVE = '#4CD964';
export const HAPPY_GREEN = '#4CAF50';
export const GRAY_ICON_COLOR = '#5B5A5A';
export const WARNING_BACKGROUND_COLOR = 'rgba(251, 211, 10, .2)';
export const FADED_WHITE = 'rgba(255, 255, 255, 0.7)';
export const FORM_BACKGROUND_COLOR = '#F9F9F9';

export const MAIN_BACKGROUND_COLOR = '#F3F6Fa';
export const BILLING_BACKGROUND_COLOR = MAIN_BACKGROUND_COLOR;

export const GRAY_ICON_BACKGROUND_COLOR = '#ededed';
export const ALERT_DOT_COLOR = '#FD6A6A';

export const BRAND_MEDIUM_BLUE = '#49517D';
export const TINTS_HERO_BLUE_80 = '#D4D5DA';
export const TINTS_OFF_WHITE_80 = '#FFFEFC';

// Marketing page specific content
export const HEADLINE_GRAY = '#8A8A99';
export const DIVIDER_GRAY = '#A9A9AA';
export const MARKETING_GREEN = '#038761';

// New colors for marketing customer app
export const PRIMARY = '#1F2647';
export const PRODUCT_CARD_DARK_BLUE = '#1F2647';
export const PRODUCT_CARD_MEDIUM_BLUE_LINK = '#49517D';
export const PRODUCT_BACKGROUND = '#FFFCF5';
export const OFF_WHITE_20 = '#6F6D68';
export const HERO_BLUE_10 = '#1f26471a';

export const DESTRUCTIVE_BUTTON = '#661411';
export const DESTRUCTIVE_BUTTON_HOVER = '#841915';
